import { PercentPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressBarStatus } from '@core/enums/progress-bar-status.enum';
import { TranslateModule } from '@ngx-translate/core';
import { FormatNumberPipe } from '@portal-shared/app/pipes/format-number.pipe';

@Component({
    selector: 'al-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    imports: [PercentPipe, FormatNumberPipe, TranslateModule]
})
export class ProgressBarComponent {
  @Input()
  public value?: number;

  @Input()
  public maxValue = 1;

  public get percent() {
    const value = this.value ?? 0;
    if (this.maxValue <= 0) {
      return value <= 0 ? 0 : 100;
    }

    return value / this.maxValue;
  }

  @Input()
  public isPercent = true;

  @Input()
  public titleKey = '';

  @Input()
  public isLoading?: boolean;

  @Input()
  public status: ProgressBarStatus = ProgressBarStatus.Neutral;
}
